import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { RevisionService } from 'src/app/revisions/services/revision.service';
import { ConfirmationDialogService } from 'src/app/shared/services/confirmation-dialog.service';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import * as Actions from "../../stores/global/revision-status/actions";
import { revisionStatusSelector } from 'src/app/stores/global/revision-status/selectors';
import { ICreateRevisionStatusRequest, IGetRevisionStatusResponse, IUpdateRevisionStatusRequest } from 'src/app/revisions/models/revision-status';
import { IBaseSearchRequest, IGridResult } from 'src/app/core/models/base';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EditEvent, RemoveEvent } from '@progress/kendo-angular-grid';


@Component({
    selector: 'app-manage-revision-status',
    templateUrl: './manage-revision-status.component.html',
    styleUrl: './manage-revision-status.component.scss',
    standalone: false
})
export class ManageRevisionStatusComponent {
  isLoading$: Observable<boolean>;
  revisionStatus$: Observable<IGetRevisionStatusResponse[]>;

  constructor(    
    private route : ActivatedRoute,
    private deviceService: RevisionService,
    private appNotificationService: AppNotificationService,
    private confirmationDialogService : ConfirmationDialogService,
    private store: Store<AppStateInterface>) {
      this.revisionStatus$ = this.store.pipe(select(revisionStatusSelector))
  }
  
  revisionStatus: IGridResult<IGetRevisionStatusResponse[]>;
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;
  selectedRevisionStatus: IGetRevisionStatusResponse = null;
  isDialogActive = false;
  public editForm: UntypedFormGroup;
  isInEditing = false;

  public searchRequest : IBaseSearchRequest = {
    pageNumber:0, 
    pageSize:999999
  }

  ngOnInit(): void {
    this.store.dispatch(Actions.getRevisionStatus());
  }

  addHandler({ sender }){
    this.closeEditor(sender);
    this.isInEditing = false;

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, {
        validators: Validators.required,
        updateOn: 'change'}),
      index: new UntypedFormControl(null, {
        validators: Validators.required
      }),
      isFinalStatus: new UntypedFormControl(false)
    });

    sender.addRow(this.formGroup);
  }

  public editHandler(args: EditEvent): void{
    this.closeEditor(args.sender);
    this.isInEditing = true;

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(
        args.dataItem.name, {
          validators: Validators.required
        }),
      index: new UntypedFormControl(
        args.dataItem.index, {
          validators: Validators.required
        }),
      isFinalStatus: new UntypedFormControl(args.dataItem.isFinalStatus)
    });

    this.editedRowIndex = args.rowIndex;

    args.sender.editRow(args.rowIndex, this.formGroup);
  }

  public saveHandler(event) {
    const createRequest: ICreateRevisionStatusRequest = {
      name: event.formGroup.value.name,
      index: event.formGroup.value.index,
      isFinalStatus: event.formGroup.value.isFinalStatus
    }

    const updateRequest: IUpdateRevisionStatusRequest = {
      id: event.dataItem.id,
      name: event.formGroup.value.name,
      index: event.formGroup.value.index,
      isFinalStatus: event.formGroup.value.isFinalStatus
    }

    if (this.isInEditing) {
      this.store.dispatch(Actions.updateRevisionStatus({ revisionStatus: updateRequest }));
    } else {
      this.store.dispatch(Actions.createRevisionStatus({ revisionStatus: createRequest }));
    }
    
    event.sender.closeRow(event.rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
  
  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public removeHandler(args: RemoveEvent): void{
    var subscription : Subscription = new Subscription();
    this.confirmationDialogService.open();
    subscription = this.confirmationDialogService.decision$.subscribe(val => {
      if (val) {
        this.store.dispatch(Actions.deleteRevisionStatus({ id: args.dataItem.id }))
        this.confirmationDialogService.updateValue(false);
      } else{
        subscription.unsubscribe();
      }
    });
  }

  closeDialog(){
    this.selectedRevisionStatus = null;
    this.isDialogActive = false;
  }

  onCancel(e: PointerEvent){
    e.preventDefault();
    this.closeDialog();
  }
}
